import React, { useEffect, useState } from 'react'
import { useFormContext, useFieldArray, useWatch } from 'react-hook-form'
import { useTranslate, required, NumberInput, SelectInput } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Delete, Add } from '@mui/icons-material'
import Button from '@mui/material/Button'
import { Grid } from '@mui/material'

const correctPath = (source, parent_index) => {
  try {
    if (source && parent_index != null && parent_index != undefined) {
      return `${source}.${parent_index}.passenger`
    }
    if (source) {
      return `${source}.passenger`
    }
    return 'passenger'
  } catch (error) {
    return 'passenger'
  }
}

const SelectPassenger = ({control, passengers, customPassenger, setCustomPassenger, source, parent_index, index}) => {
    const translate = useTranslate()
    const paxId = useWatch({
      name: `${correctPath(source, parent_index)}.${index}.pax_id`,
      control,
    })

    const passengerArray = useWatch({
      name: `${correctPath(source, parent_index)}`,
      control,
    })

    // Función para actualizar el estado de los pasajeros personalizados
    const updateCustomPassengers = (newPassengers) => {
      setCustomPassenger((current) => ({
        ...current,
        [parent_index]: newPassengers,
      }));
    };


    useEffect(() => {
      if (passengerArray && Array.isArray(passengerArray)) {
        // Crear una lista de IDs de pasajeros seleccionados
        const selectedPaxIds = passengerArray.map((item) => item.pax_id).filter((id) => id !== undefined && id !== null);
  
        // Actualizar los pasajeros personalizados para deshabilitar los seleccionados
        const updatedPassengers = passengers.map((passenger) => {
          if (selectedPaxIds.includes(passenger.pax_id)) {
            return { ...passenger, disabled: true };
          }
          return { ...passenger, disabled: false };
        });
  
        updateCustomPassengers(updatedPassengers);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [passengerArray, paxId]);

  
    return (
      <EditInputsWrap label={translate('ra.field.passenger')} required md={6} className='small'>
        <SelectInput
          source={`${correctPath(source, parent_index)}.${index}.pax_id`}
          optionValue='pax_id'
          optionText={(record) => (`${record?.name} ${record?.surname}`)}
          fullWidth
          choices={customPassenger?.[parent_index] || []}
          label={''}
          validate={[required()]}
        />
      </EditInputsWrap>
    )
}

export const FieldArrayPassenger = ({ source, parent_index, item_id, passengers }) => {
  const translate = useTranslate()
  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: correctPath(source, parent_index), // unique name for your Field Array
    keyName: '_id',
  })

  const deletePassenger = (originalIndex) => {
    remove(originalIndex)
  }
  const [customPassenger, setCustomPassenger] = useState({[parent_index] : passengers})

  return (
    <>
      {React.Children.toArray(
        fields.map((field, index) => (
          <div
            key={field._id}
            style={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 10,
            }}
          >
            <Grid container spacing={3}>
              <SelectPassenger
                control={control}
                passengers={[...passengers]}
                customPassenger={customPassenger}
                setCustomPassenger={setCustomPassenger}
                index={index}
                parent_index={parent_index}
                source={source}
              />
              <EditInputsWrap label={translate('ra.field.amount')} required md={4} className='small'>
                <NumberInput
                  label={''}
                  source={`${correctPath(source, parent_index)}.${index}.amount`}
                  validate={required()}
                />
              </EditInputsWrap>

              <EditInputsWrap label={null} lg={2} md={2}>
                <Button onClick={() => deletePassenger(index)} startIcon={<Delete />} color='error'>
                  {translate('ra.action.delete')}
                </Button>
              </EditInputsWrap>
            </Grid>
          </div>
        ))
      )}
      <Button
        startIcon={<Add />}
        onClick={() => {
          append({ pax_id: null, item_id: item_id, amount: 0 })
        }}
      >
        {translate('ra.action.add_specific', {
          name: translate('ra.field.passenger'),
        })}
      </Button>
    </>
  )
}
